import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCursorToolbar = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_8687_26850)",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M6.88995 17.1283L1.16237 1.58204C1.07021 1.33188 1.31348 1.08861 1.56364 1.18077L17.1099 6.90834C17.3561 6.99906 17.3877 7.33453 17.1627 7.46954L11.16 11.0712C11.116 11.0976 11.0792 11.1344 11.0528 11.1784L7.45114 17.1811C7.31613 17.4061 6.98066 17.3745 6.88995 17.1283Z",
			stroke: "currentColor",
			strokeWidth: 1.25
		}), /* @__PURE__ */ _jsx("path", {
			d: "M14.375 14.3124L18.75 18.6874",
			stroke: "currentColor",
			strokeWidth: 1.25,
			strokeLinecap: "round"
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_8687_26850",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 20,
			height: 20,
			fill: "white",
			transform: "translate(20) rotate(90)"
		})
	}) })]
});
export default SvgCursorToolbar;
